export default {
  __name: 'VForm',
  props: {
    autocomplete: {
      type: [Boolean, String],
      default: null
    },
    onKeyPress: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // Оставлен для совместимости API потребителей (валидация вынесена в useFormValidator).
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    function handleSubmit(event) {
      event.preventDefault();
      emit('submit', event);
    }
    function handleKeyup(event) {
      event.stopPropagation();
      event.preventDefault();
      if (typeof props.onKeyPress[event.code] === 'function') {
        props.onKeyPress[event.code](event);
      }
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      handleSubmit: handleSubmit,
      handleKeyup: handleKeyup
    };
  }
};